import React from "react";
import { Button, notification } from "antd";
import { DataService } from "../../../../Services";

export const ClearCache = () => {
	const [loading, setLoading] = React.useState(false);
	return (
		<Button
			loading={loading}
			type="primary"
			onClick={async () => {
				setLoading(true);
				notification.info({
					message: "Clearing Cache",
					description: "Please wait while we clear the cache"
				});
				const response = await DataService.clearCache();
				if (response?.data?.success) {
					notification.success({
						message: "Cache Cleared",
						description: "Cache has been cleared successfully"
					});
				}
				setLoading(false);
			}}
		>
			Clear Cache
		</Button>
	);
};

export default ClearCache;
